const TrashSVG = (props) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7.5 1.5L6.75 2.25H3V3.75H3.75V15C3.75 15.3917 3.8935 15.791 4.17627 16.0737C4.45904 16.3565 4.85833 16.5 5.25 16.5H12.75C13.1417 16.5 13.541 16.3565 13.8237 16.0737C14.1065 15.791 14.25 15.3917 14.25 15V3.75H15V2.25H11.25L10.5 1.5H7.5ZM5.25 3.75H12.75V15H5.25V3.75ZM6.75 5.25V13.5H8.25V5.25H6.75ZM9.75 5.25V13.5H11.25V5.25H9.75Z" 
        fill="#475163"/>
    </svg>
)

export default TrashSVG